import React, { Component } from "react";

export interface InputProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
    disabled?: boolean;
    decimal?: boolean;
    isConfig?: boolean;
}

export default class BaseNumber extends Component<InputProps, {}> {
    inputRef: React.RefObject<HTMLInputElement>;
    useSignal: string;
    prohibitSignal: string;

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();

        this.useSignal =
            navigator.userAgent.indexOf("Firefox") !== -1 ? "." : ",";
        this.prohibitSignal =
            navigator.userAgent.indexOf("Firefox") !== -1 ? "," : ".";
    }

    isInteger = valueTest => {
        return (
            typeof valueTest === "number" &&
            isFinite(valueTest) &&
            Math.floor(valueTest) === valueTest
        );
    };

    countDecimalsPlaces = value => {
        let testValue = value
            .toString()
            .replace(this.prohibitSignal, this.useSignal);
        if (Math.floor(testValue) !== testValue) {
            let splited = testValue.split(this.useSignal);
            return splited[splited.length - 1].length || 0;
        }
        return 0;
    };

    render() {
        const {isConfig, ...restProps} = this.props
        delete restProps.decimal

        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."
            || (isConfig && !this.props.disabled)
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                  this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "input-group " + (errors ? "input-group-error" : "")
                    }
                >
                    <input
                        type="number" //{this.props.inputtype}
                        className="input"
                        ref={this.inputRef}
                        step={this.props.decimal ? "0.01" : "1"}
                        placeholder={this.props.placeholder}
                        spellCheck={false}
                        {...this.props.field}
                        {...restProps}
                        /*onKeyDown={evt => {
                            if (evt.nativeEvent.key === this.prohibitSignal) {
                                evt.nativeEvent.preventDefault();
                            }
                        }}*/
                        value={
                            this.props.field.value === 0
                                ? 0
                                : this.props.field.value || ""
                        }
                        onChange={(...args) => {
                            /*if (
                                (args[0].target.value.match(/\./g) || [])
                                    .length > 1 ||
                                (args[0].target.value &&
                                    args[0].target.value[0] == this.useSignal)
                            ) {
                                args[0].nativeEvent.preventDefault();
                            } else {
                                if (
                                    !isNaN(parseFloat(args[0].target.value)) &&
                                    !this.isInteger(
                                        parseFloat(args[0].target.value)
                                    ) &&
                                    this.countDecimalsPlaces(
                                        parseFloat(args[0].target.value)
                                    ) > 2
                                ) {
                                    let excess =
                                        this.countDecimalsPlaces(
                                            parseFloat(args[0].target.value)
                                        ) - 2;

                                    this.inputRef.current.value = args[0].target.value
                                        .toString()
                                        .slice(0, -excess);
                                } else {*/
                            const { field } = this.props;
                            let { touched } = this.props.form;
                            touched[field.name] = true;
                            this.props.form.setTouched(touched);
                            field.onChange(...args);
                            //}
                            //}
                        }}
                    />
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
